import {
  FETCH_DASHBOARD_SUMMARY_REQUEST,
  FETCH_DASHBOARD_SUMMARY_SUCCESS,
  FETCH_DASHBOARD_SUMMARY_FAILURE,
} from "./dashboardActionTypes";

const initialState = {
  loading: false,
  dashboardSummary: null,
  error: "",
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DASHBOARD_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        dashboardSummary: action.payload.data,
        error: "",
      };
    case FETCH_DASHBOARD_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        dashboardSummary: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default dashboardReducer;